module.exports = __webpack_public_path__ + "img/DZ.65a61c23.svg";